import { render } from "./Slogan.vue?vue&type=template&id=0cd6baed&scoped=true"
import script from "./Slogan.vue?vue&type=script&lang=js"
export * from "./Slogan.vue?vue&type=script&lang=js"

import "./Slogan.vue?vue&type=style&index=0&id=0cd6baed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd6baed"]])

export default __exports__